import { render, staticRenderFns } from "./sDataLaboral.vue?vue&type=template&id=066f39a2&scoped=true"
import script from "./sDataLaboral.vue?vue&type=script&lang=js"
export * from "./sDataLaboral.vue?vue&type=script&lang=js"
import style0 from "./sDataLaboral.vue?vue&type=style&index=0&id=066f39a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f39a2",
  null
  
)

export default component.exports